var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleIcon = function SvgGoogleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_575_9338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8025 10.2302C19.8025 9.55044 19.7474 8.86699 19.6298 8.19824H10.1975V12.0491H15.599C15.3748 13.291 14.6546 14.3897 13.6001 15.0878V17.5865H16.8225C18.7149 15.8448 19.8025 13.2727 19.8025 10.2302Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1975 20.0006C12.8945 20.0006 15.169 19.1151 16.8262 17.5865L13.6037 15.0879C12.7071 15.6979 11.5497 16.0433 10.2012 16.0433C7.5923 16.0433 5.38029 14.2832 4.58661 11.9169H1.26123V14.4927C2.95883 17.8695 6.41648 20.0006 10.1975 20.0006Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58296 11.9168C4.16407 10.6748 4.16407 9.32996 4.58296 8.08799V5.51221H1.26126C-0.157073 8.33786 -0.157073 11.6669 1.26126 14.4926L4.58296 11.9168Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1975 3.95805C11.6232 3.936 13.0011 4.47247 14.0336 5.45722L16.8886 2.60218C15.0808 0.904587 12.6814 -0.0287217 10.1975 0.00067389C6.41648 0.00067389 2.95883 2.13185 1.26123 5.51234L4.58293 8.08813C5.37294 5.71811 7.58863 3.95805 10.1975 3.95805Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_575_9338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.605,
    height: 20.0006,
    fill: "white",
    transform: "translate(0.19751)"
  })))));
};
export default SvgGoogleIcon;